export const iosLink = "https://apps.apple.com/us/app/dr-matary/id6463245575";
export const androidLink =
  "https://play.google.com/store/apps/details?id=com.matary";
